import React, { Dispatch, SetStateAction, useEffect } from 'react'

// ** Util Imports
import { discountFormUIConfig } from 'src/assets/DiscountsConfig'

// ** Child Imports
import DiscountSetupForm from './discount-creation-step-components/DiscountSetupForm'
import DiscountConditionForm from './discount-creation-step-components/DiscountConditionForm'
import CustomerEligibilityForm from './discount-creation-step-components/CustomerEligibilityForm'
import DiscountUsageLimitsForm from './discount-creation-step-components/DiscountUsageLimitsForm'
import DiscountPreivewForm from './discount-creation-step-components/DiscountPreviewForm'

// ** Type Imports
import {
  ActivePeriodLengthType,
  ApplicationStageType,
  DiscountFormErrorState,
  DiscountFormStateType,
  GenerationType,
  JourneyLineStepConfigType,
  JourneyStepType
} from 'src/lib/types/discounts'

interface DiscountCreationFormProps {
  discountFormState: DiscountFormStateType | undefined
  setFormState: Dispatch<SetStateAction<DiscountFormStateType | undefined>>
  currentStep: JourneyStepType
  isEditMode: boolean
  generationType: GenerationType | undefined
  journeyLineConfig: JourneyLineStepConfigType[] | undefined
  periodLength: ActivePeriodLengthType | undefined
  saveTriggered?: boolean
  applicationStage: ApplicationStageType | undefined
  formErrors: DiscountFormErrorState
  setFormErrors: Dispatch<SetStateAction<DiscountFormErrorState>>
}

const DiscountCreationForm: React.FC<DiscountCreationFormProps> = ({
  discountFormState,
  setFormState,
  currentStep,
  isEditMode,
  generationType,
  journeyLineConfig,
  periodLength,
  saveTriggered,
  applicationStage,
  formErrors,
  setFormErrors
}) => {
  const { setup, conditions, preview, customerEligibility, usageLimits, discountId } = discountFormState || {}

  const { setupUIConfig, conditionsUIConfig, eligibilityUIConfig, usageLimitsUIConfig, previewUIConfig } =
    discountFormUIConfig || {}

  const renderDiscountCreationForms = () => {
    switch (currentStep) {
      case 'setup':
        return (
          <DiscountSetupForm
            uiConfig={setupUIConfig}
            formState={setup}
            isEditMode={isEditMode}
            setFormState={setFormState}
            generationType={generationType}
            applicationStage={applicationStage}
            formErrors={formErrors}
            setFormErrors={setFormErrors}
          />
        )
      case 'condition':
        return (
          <DiscountConditionForm
            uiConfig={conditionsUIConfig}
            formState={conditions}
            isEditMode={isEditMode}
            setFormState={setFormState}
            generationType={generationType}
            applicationStage={applicationStage}
            setupStateConfig={setup}
            setupUIConfig={setupUIConfig}
            formErrors={formErrors}
            setFormErrors={setFormErrors}
          />
        )
      case 'eligibility':
        return (
          <CustomerEligibilityForm
            uiConfig={eligibilityUIConfig}
            formState={customerEligibility}
            isEditMode={isEditMode}
            setFormState={setFormState}
            generationType={generationType}
            formErrors={formErrors}
            setFormErrors={setFormErrors}
          />
        )
      case 'limits':
        return (
          <DiscountUsageLimitsForm
            uiConfig={usageLimitsUIConfig}
            formState={usageLimits}
            isEditMode={isEditMode}
            setFormState={setFormState}
            generationType={generationType}
            periodLength={periodLength}
            applicationStage={applicationStage}
            formErrors={formErrors}
            setFormErrors={setFormErrors}
            setupStateConfig={setup}
            setupUIConfig={setupUIConfig}
            discountId={discountId}
          />
        )
      case 'preview':
        return (
          <DiscountPreivewForm
            uiConfig={previewUIConfig}
            formState={discountFormState}
            isEditMode={isEditMode}
            setFormState={setFormState}
            generationType={generationType}
            saveTriggered={saveTriggered}
            formErrors={formErrors}
            setFormErrors={setFormErrors}
            applicationStage={applicationStage}
          />
        )
    }
  }

  return (
    <div className='flex flex-col w-full gap-4'>
      {/* Step distribution */}
      {renderDiscountCreationForms()}
    </div>
  )
}

export default DiscountCreationForm
